import * as ng from "@angular/core";
import * as Rx from 'rxjs'
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from "@angular/router";
import {Mag2ApiClient} from "../../lib/api-client/mag2-api-client";
import {environment} from "../../env/environment";
import {catchError, mergeMap} from "rxjs/operators";

@ng.Injectable()
export class LoginUserTermsAgreedGuard implements CanActivate {

  constructor(private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return Mag2ApiClient.getUser().pipe(
      mergeMap(user => {
        if (user == null) {
          // ログインしていない場合はスルー
          return Rx.of(true);
        }

        // ログインしている場合はチェックして agreed が true だったら true, false だったら false (リダイレクト)
        return Mag2ApiClient.getTermsAgreementStatus().pipe(
          mergeMap(status => {
            if (status.agreed) {
              return Rx.of(true)
            } else {
              return Rx.from(this.router.navigate(['terms', 'live'], {queryParams: {"to": state.url}}));
            }
          }),
          catchError(e => {
            // 同意ステータスが取れない場合にはサーバエラーを表示する
            console.error(e);
            return Rx.from(this.router.navigate(['errors', 'server'], {queryParams: {"to": state.url}}));
          })
        )
      }),
      catchError(e => {
        if (environment.production) {
          throw e
        } else {
          return Rx.of(true)
        }
      })
    );
  }

}
